import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CourseCatalogLandingPageOverview } from 'app/library/course-catalog-landing-page/models/course-catalog-landing-page-overview.model';

@Injectable()
export class CourseCatalogLandingPageService {
    private _overview$ = new BehaviorSubject<CourseCatalogLandingPageOverview | null>(null);

    setOverview(overview: CourseCatalogLandingPageOverview): void {
        this._overview$.next(overview);
    }

    get overview$() {
        return this._overview$.asObservable();
    }

    get overview(): CourseCatalogLandingPageOverview | null {
        return this._overview$.value;
    }
}
